import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { AlertsSummaryQuery, ShadowServicesQuery } from './type';
export const getAlertsSummary = async (params?: AlertsSummaryQuery) => {
  const res = await apiClient.GET('/v2/accesses/alerts/summary', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
};
export const getAlertsTrendComparison = async (params?: {
  year?: number;
  month?: number;
}) => {
  const res = await apiClient.GET('/v2/accesses/alerts/month-comparison', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
};
export const listShadowServices = async (params: ShadowServicesQuery) => {
  const res = await apiClient.GET('/v2/accesses/alerts/shadow-services', {
    params: {
      query: params
    }
  });
  return getDataOrThrowApiError(res);
};